import {
  IonButton,
  IonButtons,
  IonCard,
  IonCardHeader,
  IonCardSubtitle,
  IonCol,
  IonContent,
  IonFooter,
  IonHeader,
  IonInput,
  IonItem,
  IonItemDivider,
  IonItemGroup,
  IonLabel,
  IonModal,
  IonRow,
  IonSelect,
  IonSelectOption,
  IonTextarea,
  IonTitle,
  IonToolbar,
  useIonToast,
} from "@ionic/react";
import { nanoid } from "nanoid";
import React, { useState } from "react";
import variants from "../../utils/variants.js";
import { useFirebase } from "../firebase-provider.jsx";

import PageLayout from "../layout";

interface ProductData {
  category: string;
  sku: string;
  brand: string;
  product_name: string;
  price: number;
}

const AddProduct: React.FC<any> = ({ history }) => {
  // Controller State
  const [modal, setModal] = useState<{ active: boolean; content: any }>({
    active: false,
    content: {},
  });

  const [submit, setSubmit] = useState<{ text: string; status: boolean }>({
    text: "Buat Produk",
    status: false,
  });
  // Data State

  const [toast] = useIonToast();

  const [productData, setProductData] = useState<ProductData>({
    category: "Kaos",
    sku: `TPK-${nanoid(4)}`,
    brand: "Tapak Apparel",
    product_name: "",
    price: 0,
  });

  const [variantData, setVariantData] = useState<any>({
    warna: [],
    ukuran: [],
  });

  const [allVariant, setAllVariant] = useState<any>([]);

  // Change Handler
  const handleProductForm = (e: any) =>
    setProductData({
      ...productData,
      [e.target.name]: e.detail.value,
    });

  const allVariantData = variants(variantData);

  const varianForm = (
    <>
      <IonItemGroup>
        {Object.keys(variantData).map((el: string) => (
          <React.Fragment key={el}>
            <IonItemDivider>
              <IonLabel>{el === "warna" ? "Warna" : "Ukuran"}:</IonLabel>
            </IonItemDivider>
            <IonItem>
              <IonLabel position="stacked" color="medium">
                Pisahkan {el} dengan tanda koma.
              </IonLabel>
              <IonTextarea
                onIonBlur={() => {
                  let allvar: Array<any> = allVariantData.map((e: any) => ({
                    sku: `${productData.sku}-${Object.values(e)
                      .join("-")
                      .toUpperCase()}`,
                    stock: 1,
                    data: e,
                    price_changes: 0,
                  }));
                  setAllVariant(allvar);
                }}
                onIonChange={(e: any) =>
                  setVariantData({
                    ...variantData,
                    [el]: e.detail.value
                      .split(",")
                      .map((e: any) => e.replace(/^\s+|\s+$/, ""))
                      .filter((e: any) => e !== ""),
                  })
                }
                placeholder={
                  el === "warna" ? "Merah, Kuning, Hijau" : "S, M, L, XL"
                }
              ></IonTextarea>
            </IonItem>
          </React.Fragment>
        ))}
      </IonItemGroup>
    </>
  );

  // SetProduct
  const { database } = useFirebase();
  const setProduct = async () => {
    setSubmit({ text: "Membuat Produk...", status: true });
    var newProduct = database.ref("product/" + productData.sku);
    var updateSku = database.ref("stock");

    const varian = allVariant.map((e: any) => ({
      price_changes: e.price_changes,
      sku: e.sku,
      data: e.data,
    }));

    const sku_data = allVariant.map((e: any) => ({
      [e.sku]: e.stock,
    }));

    const data = {
      id: newProduct.key,
      ...productData,
      varian: varian,
    };

    const setSku = updateSku.update(Object.assign({}, ...sku_data));

    const setProduct = newProduct.set(data);

    Promise.all([setSku, setProduct])
      .then(() => {
        toast({
          message: "Produk berhasil dibuat!",
          duration: 3000,
          color: "success",
          position: "top",
        });
        history.push(`/app/product`);
      })
      .catch(() => {
        toast({
          message: "Terjadi Kesalahan! Produk gagal dibuat!",
          duration: 1000,
          color: "danger",
          position: "top",
        });
      });

    setSubmit({ text: "Buat Produk", status: false });
  };

  return (
    <PageLayout title="Tambahkan Produk">
      <IonCard className="ion-margin-bottom">
        <IonCardHeader>
          <IonCardSubtitle>Merk &amp; Kategori</IonCardSubtitle>
        </IonCardHeader>

        <IonItem>
          <IonLabel position="stacked">Kategori</IonLabel>
          <IonSelect
            name="category"
            value={productData.category}
            cancelText="Batal"
            onIonChange={handleProductForm}
          >
            <IonSelectOption value="Kaos">Kaos</IonSelectOption>
            <IonSelectOption value="Kaos Anak">Kaos Anak</IonSelectOption>
            <IonSelectOption value="Jaket/Sweater">
              Jaket/Sweater
            </IonSelectOption>
          </IonSelect>
        </IonItem>

        <IonItem lines="none">
          <IonLabel position="stacked">Merk</IonLabel>
          <IonInput
            name="brand"
            value={productData.brand}
            onIonChange={handleProductForm}
          ></IonInput>
        </IonItem>

        <IonCardHeader>
          <IonCardSubtitle>Rincian Produk</IonCardSubtitle>
        </IonCardHeader>

        <IonItem>
          <IonLabel position="stacked">Nama Produk</IonLabel>
          <IonInput
            name="product_name"
            value={productData.product_name}
            onIonChange={handleProductForm}
          ></IonInput>
        </IonItem>

        <IonItem>
          <IonLabel position="stacked">SKU (Stock Keeping Unit)</IonLabel>
          <IonInput
            name="sku"
            value={productData.sku}
            onIonChange={handleProductForm}
          ></IonInput>
        </IonItem>

        <IonItem>
          <IonLabel position="stacked">Harga (IDR)</IonLabel>
          <IonInput
            name="price"
            value={productData.price}
            type="number"
            onIonChange={handleProductForm}
          ></IonInput>
        </IonItem>

        <IonCardHeader>
          <IonCardSubtitle>Warna dan Ukuran</IonCardSubtitle>
        </IonCardHeader>
        {varianForm}

        <IonCardHeader>
          <IonCardSubtitle>Stok dan Perubahan Harga</IonCardSubtitle>
        </IonCardHeader>
        {allVariant.length === 0 && (
          <IonItem>
            <IonLabel>
              <p>Ukuran atau warna belum di atur.</p>
            </IonLabel>
          </IonItem>
        )}
        {allVariant.length >= 1 &&
          allVariant.map((e: any, i: number) => {
            return (
              <React.Fragment key={e.sku}>
                <IonItem
                  lines="full"
                  button
                  onClick={() =>
                    setModal({ active: true, content: { data: e, index: i } })
                  }
                >
                  <IonRow>
                    <IonCol>
                      <IonLabel color="medium">
                        {Object.values(e.data).join(" / ")}
                      </IonLabel>
                    </IonCol>
                  </IonRow>

                  <IonLabel slot="end">Stok: {e.stock}</IonLabel>
                  <IonLabel slot="end">
                    {new Intl.NumberFormat("id-ID", {
                      style: "currency",
                      currency: "IDR",
                      maximumSignificantDigits: 10,
                    }).format(
                      Number(productData.price) + Number(e.price_changes)
                    )}
                  </IonLabel>
                </IonItem>
              </React.Fragment>
            );
          })}
      </IonCard>

      {/* MODAL */}
      <IonModal
        isOpen={modal.active}
        swipeToClose={true}
        onDidDismiss={() => setModal({ active: false, content: "" })}
        cssClass="product-variant-modal"
      >
        <IonHeader translucent>
          <IonToolbar>
            <IonTitle>Edit varian</IonTitle>
            <IonButtons slot="end">
              <IonButton
                onClick={() => setModal({ active: false, content: "" })}
              >
                Tutup
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonItemGroup>
            
            <IonItem lines='full'>
              <IonLabel position="stacked">Stok</IonLabel>
              <IonInput
                value={modal?.content?.data?.stock || 0}
                type="number"
                onIonChange={(event) =>
                  setModal({
                    ...modal,
                    content: {
                      ...modal.content,
                      data: {
                        ...modal.content.data,
                        stock: event.detail.value,
                      },
                    },
                  })
                }
              ></IonInput>
            </IonItem>

            <IonItem lines='none'>
              <IonLabel position="stacked">Perubahan harga</IonLabel>
              <IonInput
                value={modal?.content?.data?.price_changes || 0}
                type="number"
                onIonChange={(event) =>
                  setModal({
                    ...modal,
                    content: {
                      ...modal.content,
                      data: {
                        ...modal.content.data,
                        price_changes: event.detail.value,
                      },
                    },
                  })
                }
              ></IonInput>
            </IonItem>
          </IonItemGroup>
        </IonContent>
        <IonFooter translucent>
          <IonToolbar>
            <IonButton
              fill="clear"
              color="primary"
              disabled={allVariant[modal.content.index] === modal.content.data}
              onClick={() => {
                let newAllVariant = [...allVariant];
                newAllVariant[modal.content.index] = modal.content.data;
                setAllVariant(newAllVariant);
                setModal({ active: false, content: "" });
                toast({
                  message: "Perubahan disimpan",
                  duration: 1000,
                  color: "success",
                  position: "top",
                });
              }}
            >
              Simpan
            </IonButton>

            <IonButton
              color="danger"
              fill="clear"
              onClick={() => {
                let newAllVariant = [...allVariant].filter(
                  (e, i) => i !== modal.content.index
                );
                setAllVariant(newAllVariant);
                setModal({ active: false, content: "" });
              }}
            >
              Hapus Varian
            </IonButton>
          </IonToolbar>
        </IonFooter>
      </IonModal>
      <IonButton
        className="ion-margin"
        fill="outline"
        disabled={submit.status}
        onClick={setProduct}
      >
        {submit.text}
      </IonButton>
    </PageLayout>
  );
};

export default AddProduct;
